import {
  AccountStatusInElectric,
  AppDevicesResponse,
  AppUserAccountsResponse,
  AssetStatus,
  OperationResultOutcome,
} from '@electricjs/core_entity-client';

import { simpleEmployee, appsOnlyEmployee } from '@/mocks/data/employeeData';

export const appUserAccountsResponse: AppUserAccountsResponse = {
  result: OperationResultOutcome.Success,
  user_accounts: [
    {
      email: 'simple-user@simple-org.com',
      status_in_electric: AccountStatusInElectric.Active,
      employee_info: { id: simpleEmployee.id },
      account_info: {
        id: 'third-party-account-1',
        disabled: false,
        created_at: '2024-01-15T10:00:00.000Z',
      },
    },
    {
      email: 'alex.apps@simple-org.com',
      status_in_electric: AccountStatusInElectric.Active,
      employee_info: { id: appsOnlyEmployee.id },
      account_info: {
        id: 'third-party-account-2',
        disabled: false,
        created_at: '2024-03-02T10:00:00.000Z',
      },
    },
    {
      email: 'former.employee@simple-org.com',
      status_in_electric: AccountStatusInElectric.Inactive,
      employee_info: {
        id: 'former-employee-id',
        offboarded_at: '2024-06-01T10:00:00.000Z',
      },
      account_info: { id: 'third-party-account-3', disabled: false },
    },
    {
      email: 'unrecognized@external.com',
      status_in_electric: AccountStatusInElectric.UnknownEmail,
      account_info: { id: 'third-party-account-4', disabled: true },
    },
  ],
};

export const appDevicesResponse: AppDevicesResponse = {
  result: OperationResultOutcome.Success,
  devices: [
    {
      external_id: 'external-device-1',
      serial_number: 'C02ZK4W4LVDL',
      status: AssetStatus.InUse,
      asset_info: {
        id: 'bd46fce5-bc6b-403d-ab12-94a059ea0cec',
        assigned_to_employee_id: simpleEmployee.id,
      },
      device_info: {
        device_name: 'MacBookPro15,2',
        brand: 'Apple',
        hardware_model: 'MacBookPro15,2',
        os_type: 'darwin',
        os_version: '14.4.0',
        os_name: 'Sonoma',
        enrolled_at: '2024-07-15T17:59:22.622Z',
        last_seen_at: '2024-09-17T01:19:37.926Z',
        assigned_user_email: 'simple-user@simple-org.com',
      },
    },
    {
      // Device known to the third party but not tracked as an Electric asset.
      external_id: 'external-device-2',
      serial_number: 'UNTRACKED123',
      device_info: {
        device_name: 'Untracked Laptop',
        brand: 'Lenovo',
        os_type: 'windows',
        os_version: '11',
      },
    },
  ],
};
